import lockIcon from "@tabler/icons/outline/lock.svg";
import worldIcon from "@tabler/icons/outline/world.svg";
import React from "react";
import { FormattedMessage } from "react-intl";

import { HStack, Icon, Popover, Stack, Text } from "@/components/ui";

import type { Group } from "@/schemas";

interface GroupPolicyProps {
  group: Group;
  isMinimal?: boolean;
}

const GroupPrivacy = ({ group, isMinimal }: GroupPolicyProps) => {
  const isPrivate = group.group_visibility === "members_only";
  const isLocked = group.locked;

  return (
    <Popover
      referenceElementClassName="cursor-help"
      content={
        <Stack space={4} alignItems="center" className="w-80">
          <div className="rounded-full bg-gray-200 p-3 dark:bg-gray-800">
            <Icon
              src={isPrivate ? lockIcon : worldIcon}
              className="size-6 text-gray-600 dark:text-gray-600"
            />
          </div>

          <Stack space={1} alignItems="center">
            <Text size="lg" weight="bold" align="center">
              {isPrivate ? (
                <FormattedMessage
                  id="group.privacy.locked.full"
                  defaultMessage="Private Group"
                />
              ) : (
                <>
                  {!isLocked ? (
                    <FormattedMessage
                      id="group.privacy.public.full"
                      defaultMessage={"Public Group"}
                    />
                  ) : (
                    <FormattedMessage
                      id="group.privacy.limited.full"
                      defaultMessage={"Public Group (Approval required)"}
                    />
                  )}
                </>
              )}
            </Text>

            <Text theme="muted" align="center">
              {isPrivate ? (
                <FormattedMessage
                  id="group.privacy.locked.info"
                  defaultMessage="Discoverable. Users can join after their request is approved."
                />
              ) : (
                <>
                  {!isLocked ? (
                    <FormattedMessage
                      id="group.privacy.public.info"
                      defaultMessage="Discoverable. Anyone can join."
                    />
                  ) : (
                    <FormattedMessage
                      id="group.privacy.limited.info"
                      defaultMessage="Discoverable but members must be approved by the group admins. Group Truths appear in group members home feeds and can be shared with non-members."
                    />
                  )}
                </>
              )}
            </Text>
          </Stack>
        </Stack>
      }
    >
      <HStack space={1} alignItems="center" data-testid="group-privacy">
        <Icon className="size-4" src={isPrivate ? lockIcon : worldIcon} />
        {!isMinimal && (
          <Text theme="inherit" tag="span" size="sm" weight="medium">
            {isPrivate ? (
              <FormattedMessage
                id="group.privacy.locked"
                defaultMessage="Private"
              />
            ) : (
              <FormattedMessage
                id="group.privacy.public"
                defaultMessage="Public"
              />
            )}
          </Text>
        )}
      </HStack>
    </Popover>
  );
};

export default GroupPrivacy;
